import { render, staticRenderFns } from "./TableAverageSpd.vue?vue&type=template&id=e3132484"
import script from "./TableAverageSpd.vue?vue&type=script&lang=js"
export * from "./TableAverageSpd.vue?vue&type=script&lang=js"
import style0 from "./TableAverageSpd.vue?vue&type=style&index=0&id=e3132484&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports